import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "../slices/authSlice";
import { userSlice } from "../slices/userSlice";
import { settingsSlice } from "../slices/settingsSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    user: userSlice.reducer,
    settings: settingsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
